import { useCallback, useState } from 'react';

export const useMergedState = (initialState) => {
  const [state, setState] = useState(initialState);
  const updateState = useCallback((newState = {}) => setState((state) => ({ ...state, ...newState })), []);
  return [state, updateState];
};

export default useMergedState;
